import { ActionContext } from 'vuex'
import infoRepository from '@/repositories/infoRepository'
import Employee from '@/models/info.model'

interface InfoState {
  info: Employee | undefined
  networkState: string | undefined
}

type InfoActionContext = ActionContext<InfoState, unknown>

const infoModule = {
  namespaced: true,
  state: (): InfoState => ({
    info: undefined,
    networkState: undefined
  }),
  getters: {
    getInfo: (state: InfoState) => state.info,
    getNetworkState: (state: InfoState) => state.networkState
  },
  mutations: {
    SET_INFO (state: InfoState, info: Employee) {
      state.info = info
    },
    SET_OFFLINE (state: InfoState, networkState: string) {
      state.networkState = networkState
    }
  },
  actions: {
    async fetchEmployeeInfo ({ state, commit }: InfoActionContext) {
      const data = await infoRepository.getEmployeeInfo()
      if (data.state === 'success') {
        commit('SET_INFO', data.data)
      }
      commit('SET_OFFLINE', data.state)
    }
  }
}

export default infoModule
